module.exports = __webpack_public_path__ + "img/86.93091842.png";